import React, { useEffect, useState } from 'react';
import { ColumnsType } from 'antd/lib/table';
import { RouteComponentProps, withRouter } from 'react-router';
import { TableCommon } from 'common/components/TableCommon';
import { IBaseFilterModel } from 'common/models/requestModels';
import { objectToQuery, queryToObject } from 'common/helpers/filters.helper';
import { ERoutesPrivate } from 'common/models/routesModel';
import { dateFormatter } from 'common/helpers/date.helper';
import { DATE_FORMAT_WITH_TIME } from 'common/const/common.const';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { getAnnouncementCollection, setAnnouncementCollection } from 'app/store/reducers/announcement.reducer';
import {
  IAnnouncementCollection,
  IAnnouncementCollectionFilter,
  IAnnouncementModel,
} from 'entities/Announcement/Announcement.models';

interface IComponentProps {
  config: ColumnsType<any>;
  filter: IAnnouncementCollectionFilter;
}

type AllProps = IComponentProps & RouteComponentProps;

const AnnouncementTableComponent: React.FC<AllProps> = ({ filter, config, history }) => {
  const dispatch = useAppDispatch();
  const { announcementCollection, announcementCollectionLoading } = useAppSelector((state) => state.announcement);
  const [mappedCollection, setMappedCollection] = useState<IAnnouncementCollection | null>(null);

  const loadCollection = (params: IBaseFilterModel) => {
    const filterParams: IAnnouncementCollectionFilter = { ...params };

    if (filter?.name) {
      filterParams.name = filter?.name;
    }
    if (filter?.storeId) {
      filterParams.storeId = filter?.storeId;
    }
    if (filter?.statuses) {
      filterParams.statuses = filter?.statuses;
    }

    dispatch(getAnnouncementCollection(filterParams));
  };

  const getCollection = (announcementCollection: IAnnouncementCollection | null) => {
    if (announcementCollection?.data) {
      const mappedData: IAnnouncementModel[] = announcementCollection.data.map((item: IAnnouncementModel) => {
        return {
          ...item,
          startDate: dateFormatter(item.startDate, DATE_FORMAT_WITH_TIME),
          endDate: dateFormatter(item.endDate, DATE_FORMAT_WITH_TIME),
        };
      });
      return {
        ...announcementCollection,
        data: mappedData,
      };
    } else {
      return announcementCollection;
    }
  };

  const addQuery = (pageIndex: number) => {
    const searchObject = queryToObject<IAnnouncementCollectionFilter>({
      pageIndex: 1,
      name: undefined,
      storeId: undefined,
      statuses: undefined,
    });
    const search = objectToQuery({ ...searchObject, pageIndex });

    return history.replace({ search });
  };

  const onRowClick = (item: IAnnouncementModel) => {
    history.push(`${ERoutesPrivate.Announcements}/${item.id}`);
  };

  const clearCollection = () => {
    return dispatch(setAnnouncementCollection(null));
  };

  useEffect(() => {
    setMappedCollection(getCollection(announcementCollection));
  }, [announcementCollection]);

  return (
    <TableCommon
      config={config}
      filter={filter}
      collection={mappedCollection}
      loading={announcementCollectionLoading}
      loadCollection={loadCollection}
      clearCollection={clearCollection}
      onRowClick={onRowClick}
      addQuery={addQuery}
    />
  );
};

export const AnnouncementTable = withRouter(AnnouncementTableComponent);
